import { Helmet } from 'react-helmet-async';
import { defaultSEO } from '../../config/seo';

export function MetaTags({
  title = defaultSEO.title,
  description = defaultSEO.description,
  keywords = defaultSEO.keywords,
  openGraph = defaultSEO.openGraph,
  noindex = false
}) {
  const fullTitle =
    title === defaultSEO.title ? title : `${title} | Plant Identifier`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={openGraph.url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={openGraph.type} />
      <meta property="og:url" content={openGraph.url} />
      <meta property="og:site_name" content={openGraph.siteName} />
      <meta property="og:locale" content={openGraph.locale} />
      {openGraph.images?.map((image, index) => (
        <meta key={index} property="og:image" content={image.url} />
      ))}

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {openGraph.images?.[0] && (
        <meta name="twitter:image" content={openGraph.images[0].url} />
      )}

      {/* PWA Meta Tags */}
      <meta name="application-name" content="Plant Identifier" />
      <meta name="apple-mobile-web-app-title" content="Plant Identifier" />
      <meta name="theme-color" content="#10b981" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
    </Helmet>
  );
}
